import axios from 'axios'
import jwtToken from './getJwtToken'

const RELEASES_API_URL = process.env.VUE_APP_RELEASES_API_URL

export default axios.create({
  baseURL: `${RELEASES_API_URL}/api`,
  headers: {
    Authorization: `Bearer ${jwtToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})
